<template>
  <base-card v-if="bkConfirmStatus">
    <h3>BOOKING DETAILS:</h3>
    <div>
      <p><b>Avenue :</b> {{ bkDetails.VenueName }}</p>
      <!--p><b>Address :</b> 86 Avoca road wakeley</p-->
      <p>
        <b>Time of Booking:</b> {{ bkDetails.StartDate }} to
        {{ this.theEndDate + ' ' + new Date( new Date(dateFormJoin(bkDetails.EndDate)).getTime() + 1000 * 60 ).toLocaleTimeString('en-US', {
            // en-US can be set to 'default' to use user's browser settings
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
      }) }}
      </p>

      <p><b>Amount Payable : </b>${{ price }} GST inclusive</p>
      <p>surcharge of 0.75% card payment applied</p>
      <p><b>Total Amount: </b>${{ priceIncludeSurcharge }}</p>
      <br />
      <p>
        **We accept Visa or Mastercard. A service fee of 0.75% (GST included)
        applies to all credit card transactions
      </p>
    </div>
  </base-card>

  <base-card v-else>
    <p>Unfortunately your session has expired.</p>
    <P>
      If you still wish to make a booking, please recommence your booking
      enquiry.
    </P>
  </base-card>

  <transition name="fade" mode="out-in">
    <p v-if="readyToPay" v-show="bkConfirmStatus">
      <credit-card-payment
        :intendToPayBookingDetails="intendToPayBookingDetails"
        :solution="solutionObject"
      ></credit-card-payment>
    </p>
    <p v-else v-show="price < 0">
      Sorry this booking is not available or booking time not allowed
    </p>
  </transition>
</template>

<script>
import CreditCardPayment from './CreditCardPayment.vue';
import { smartPricingAPI, surchargeRate, bookingCheckpoint, fcctoken } from '../../../../config';


// function dateFormJoiner(date) {
//   const dateStr = String(date);
//   const dateParts = dateStr.split('-');
//   //  console.log(date, dateStr);
//   const newDateStr = dateParts[2] + '/' + dateParts[1] + '/' + dateParts[0];

//   return newDateStr;
// }

export default {
  inject: [
    'getBookingConfirmStatus',
    'resources',
    'setSelectedTag',
    'setBookingCharges',
  ],
  components: { CreditCardPayment },
  props: ['solutions'],
  data() {
    return {
      currentEnv: null,

      token: '',
      solutionObject: null,
      theEndDate: null,
      price: 0,
      surcharge: 0,
      priceIncludeSurcharge: 0,

      readyToPay: false,

      intendToPayBookingDetails: [],

      bkConfirmStatus: false,
      bkDetails: null,
    };
  },

  activated() {
    if (this.solutions.user !== null && this.solutions.user.oid !== null) {
      this.facilityPrice(this.solutions.user.oid);
    } else {
      return;
    }
    this.checkPointData();
    this.solutionObject = this.solutions;
  },

  mounted() {
    const bookingStatusDetails = this.getBookingConfirmStatus();

    if (bookingStatusDetails.bkDetails == null) {
      return;
    }
    this.bkConfirmStatus = bookingStatusDetails.bkStatus;
    this.bkDetails = bookingStatusDetails.bkDetails;

    this.token = bookingStatusDetails.token;

    this.solutionObject = this.solutions;

    if (this.solutions.env !== null) {
      this.currentEnv = this.solutions.env;
    }


    // listen and reset

    this.$eventBus.on('search-again', () => this.resetData());
  },

  watch: {
    price() {
      if (this.price <= 0) {
        this.readyToPay = false;
      }
    },

    currentEnv() {
      // console.log(this.solutions.user.oid);
      if (this.solutions.user !== null && this.solutions.user.oid !== null) {
        this.facilityPrice(this.solutions.user.oid);
      } else {
        return;
      }
    },
  },

  computed: {},

  methods: {

    checkPointData() {

      var myHeaders = new Headers();
      myHeaders.append('Authorization', fcctoken);
      myHeaders.append('Content-Type', 'application/json');

      let checkpoint = {};
      checkpoint.OpportunityId = this.bkDetails.OpportunityId,
      checkpoint.VenueBlockId = this.bkDetails.VenueBlockId,
      checkpoint.VenueId = this.bkDetails.VenueId,
      checkpoint.VenueName = this.bkDetails.VenueName,
      checkpoint.FirstName = this.solutions.user.firstName,
      checkpoint.LastName = this.solutions.user.lastName,
      checkpoint.Phone = this.solutions.user.phone,
      checkpoint.Email = this.solutions.user.email,
      checkpoint.Notes = this.solutions.user.notes,
      checkpoint.StartDate = this.bkDetails.StartDate,
      checkpoint.EndDate = this.bkDetails.EndDate
      var raw = JSON.stringify(checkpoint);

      var request = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
      };
      var url = this.currentEnv.gateway + bookingCheckpoint;
      fetch(url, request)
      .then((response) => response.json());
    },


    resetData() {},

    dateFormJoin(date) {
      const dateStr = date;
      const date1 = dateStr.split(' ');
      this.theEndDate = date1[0];
      const dateParts = date1[0].split('/');
      const newDateStr = dateParts[2] + '-' + dateParts[1] + '-' + dateParts[0] + ' ' + date1[1];
      return newDateStr;
    },

    async facilityPrice(oid) {
      // console.log(oid);
      let myHeaders = {
        Authorization: 'Bearer ' + this.token,
        'Content-Type': 'application/json',
      };

      // Facility details to be passed dynamically...below static data for TESTING.

      //   console.log('here payment page', this.bkDetails);

      let facility = JSON.stringify({
        VenueId: this.bkDetails.VenueId, //this.smartPricingCatalogueID, //this.bkDetails.venueid, // this is smart pricing catelogue id e.g. hourly daily, weekly or monthly, yearly
        VenueName: this.bkDetails.VenueName,
        StartDate: this.bkDetails.StartDate,
        EndDate: this.bkDetails.EndDate,
        Opportunity: {
          Number: oid,
        },
      });

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: facility,
        redirect: 'follow',
      };
      // console.log(requestOptions)
      // console.log(this.currentEnv.priava + smartPricingAPI)
      fetch(this.currentEnv.priava + smartPricingAPI, requestOptions)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
            // console.log('Smart Price result: ', data);
          if (data.success) {
            let totalPrice = data.AdditionalInfo.TotalPrice;
            this.price = parseFloat(totalPrice).toFixed(2);
            this.surcharge = (this.price * surchargeRate).toFixed(2);
            this.priceIncludeSurcharge = (
              this.price *
              (1.0 + surchargeRate)
            ).toFixed(2);

            this.intendToPayBookingDetails.price = this.price;
            this.intendToPayBookingDetails.surcharge = this.surcharge;
            this.intendToPayBookingDetails.priceIncludeSurcharge =
              this.priceIncludeSurcharge;
            this.setBookingCharges(this.intendToPayBookingDetails);
            this.readyToPay = true;
            //  console.log('ready to pay here', this.readyToPay);
          } else {
            // console.log('result: ', data);
          }
        })
        .catch((error) => {
          console.log('error', error);
        });
    },
  },
};
</script>

<style scoped>
label {
  font-weight: bold;
  display: block;
  margin-bottom: 0.5rem;
}

input,
textarea {
  display: block;
  width: 100%;
  font: inherit;
  padding: 0.15rem;
  border: 1px solid #ccc;
}

input:focus,
textarea:focus {
  outline: none;
  border-color: #3a0061;
  background-color: #f7ebff;
}

.fade-enter-active {
  transition: opacity 0.75s ease-in-out;
}

.fade-enter-from {
  opacity: 0;
}
</style>
